/*
 * @Author: linbin@leedarson.com
 * @Date: 2022-05-05 15:31:26
 * Copyright © Leedarson. All rights reserved.
 */

import { SENSOR_LOGIN_ID } from '@root/constant';
import { getCurrentAuth } from '@root/shared/currentAuth';

// import sensors from 'sa-sdk-javascript';

// select
// time, distinct_id,
// `$app_version`, `$is_first_day`, `$url`, `$receive_time`,
// `$manufacturer`,`$model`,`$os`,`$os_version`,`$screen_height`,`$screen_width`,`$wifi`,`$carrier`,`$network_type`,`$device_id`,
// `$browser`, `$browser_version`,
// `$lib`,`$lib_version`, `$lib_method`,
// `$ip`, `$country`,`$province`, `$city`,
// web_version, app_name, event, eventName
// from events
// where event = '$pageview'
// order by time desc
// limit 5

// https://test-US-datalink.arnoo.com/sa?project=default
// https://pre-US-datalink.arnoo.com/sa?project=pre_release
// https://prod-US-datalink.arnoo.com/sa?project=production

const getServerUrl = () => {
  const { REACT_APP_SERVER_ENV, REACT_APP_REGION } = process.env;
  if (REACT_APP_REGION === 'us') {
    if (REACT_APP_SERVER_ENV === 'prod') {
      return `https://${REACT_APP_SERVER_ENV}-US-datalink.arnoo.com/sa?project=production`;
    }

    if (REACT_APP_SERVER_ENV === 'pre') {
      return `https://${REACT_APP_SERVER_ENV}-US-datalink.arnoo.com/sa?project=pre_release`;
    }

    return `https://${REACT_APP_SERVER_ENV}-US-datalink.arnoo.com/sa?project=default`;
  }
  return '';
};

const loggerOperator = {
  instance: null,
  loading: false,
  firstPageDelayReport: false, // 第一个页面延迟上报
  init() {
    try {
      if (this.loading) {
        return; // 注意: 避免多次初始化时，重复加载资源
      }
      if (this.instance) {
        return; // 注意: 只能初始化一次，神策要求
      }
      // 3.25.0 神策只部署了US区域
      let serverURL = getServerUrl();
      if (!serverURL) {
        return;
      }
      if (!/(http|https):\/\/([\w.]+\/?)\S*/.test(serverURL)) {
        return; // 注意: 非HTTP连接
      }
      this.loading = true;
      setTimeout(() => {
        import('sa-sdk-javascript').then(({ default: sensors }) => {
          // 1. 初始化神策
          sensors.init({
            app_js_bridge: false, // 调用原生JSBridge接口上传数据
            server_url: serverURL, // 数据接收地址
            show_log: false, // 浏览器开发者工具会打印采集的事件信息, 相当于调用`getPresetProperties()`方法
            is_track_single_page: false, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
            use_client_time: true, // 使用客户端时间
            send_type: 'image', // 发送数据方式
          });
          // 2. 注册公共属性
          sensors.registerPage({
            app_name: 'AiDot',
            // app_version: isIos ? IOS_VERSION : ANDROID_VERSION,
            // web_version: WEB_VERSION,
            platform_type: 'App',
            is_login: false,
            is_vip: false,
          });
          // 3. 实例赋值
          this.instance = sensors;
          // 采集`$pageview`事件, 因为`react-router-dom`路由拦截比`pushState`和`replaceState`时机更晚，神策会先上报，所以改成手动上报
          // sensors.quick('autoTrack');
          // 4. 第一个页面延迟上报
          // 暂时不需要页面级别的数据上报
          // if (this.firstPageDelayReport) {
          //   this.firstPageDelayReport = false;
          //   sensors.quick('autoTrackSinglePage');
          // }

          setTimeout(() => {
            const userInfo = getCurrentAuth();
            const loginId =
              localStorage.getItem(SENSOR_LOGIN_ID) || userInfo.id;
            if (loginId) {
              sensors.loginWithKey('$identity_login_id', loginId); // "type": "track_signup", "event": $SignUp, users/second_id
              sensors.registerPage({
                is_login: true,
              });
              // sensors.track('CloudServiceClickSubscribe', { price: 1.99 });
            }
          }, 300);
        });
      }, 100);
      // 初始化
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  },
  // destroy() {
  //   if (this.instance) {
  //     this.instance.para.server_url = '';
  //     this.instance = null;
  //   }
  // },
};

// window.loggerOperator = loggerOperator;

const loggerOperatorOnTrack = (event, params) => {
  if (loggerOperator.instance) {
    loggerOperator.instance.track(event, params);
  }
};

export { loggerOperatorOnTrack };

export default loggerOperator;

// 等同于`show_log: true`参数设置
// sensors.quick('isReady', () => {
//   console.log(sensors.getPresetProperties());
// });
